export const AncillaryType = {
    AirportTransfer: "AIRPORT_TRANSFER",
    SSRInFlight: "SSR_IN_FLIGHT",
    Meal: "MEAL"
}